export default __webpack_public_path__ + "static/media/RC-JavaScript-Inicial.3d39bb0c.png";